export const it = {
  welcome: 'benvenuto',
  logout: 'esci',
  trading_accounts: 'conti di trading',
  account_list: 'elenco conti',
  create_live_account: 'crea un conto live',
  upgrade_to_live_account: 'passa ad un conto live',
  create_demo_account: 'crea un conto demo ',
  finance: 'Gestione fondi',
  deposit_funds: 'Effettua un deposito',
  withdraw_funds: 'Effettua un prelievo ',
  internal_transfer: 'trasferimento interno',
  external_transfer: 'trasferimento esterno',
  transfer_back: 'annulla trasferimento',
  transfer_back_to_my_local_depositor: 'Ritrasferisci al depositante locale',
  transfer_to_external_account: 'trasferisci ad un conto esterno ',
  payment_history: 'storico pagamenti',
  my_cards: 'le mie carte',
  my_profile: 'il mio profilo',
  personal_information: 'informazioni personali',
  change_password: 'cambia password',
  upload_documents: 'carica documenti',
  partner: 'partner',
  overview: 'generale',
  clients: 'clienti',
  sub_ibs: 'sub ibs',
  payout: 'pagamenti',
  marketing_material: 'materiale di marketing',
  withdrawal_history: 'storico prelevamenti',
  become_a_partner: 'diventa partner',
  please_fill_the_following_fields: 'per favore compila i seguenti campi ',
  what_geographic_region: 'Su quale area geografica ti concentrerai maggiormente?',
  submit: 'invia',
  upload_documents_notice: 'Per completare la verifica del tuo conto e poter cominciare ad operare, <a>per favore carica I tuoi documenti</a>',
  change_password_ta_notice: "La tua nuova password verra' associata a tuti i tuoi conti nuovi.I conti gia 'esistenti non verranno modificati.",
  changepass_error: "La password corrente non e'corretta.Per favore riprova.",
  changepass_success: "La tua password e'stata modificata",
  current_password: 'Password attuale',
  new_password: 'nuova password',
  confirm_new_password: 'Conferma la nuova password',
  pending_account: 'Conto in sospeso',
  account_must_be_approved_message: 'Il tuo conto deve essere approvato prima di poter creare un nuovo conto live.',
  new_trading_account_message: 'Nuovo conto di trading creato con successo.',
  password_generated_for_ta: 'Ti abbiamo inviato una password via email per il tuo nuovo account. ',
  new_trading_account_type_message: 'Nuovo conto {type} creato con successo',
  choose_your_desired_trading_platform_and_settings: 'Scegli la tua piattaforma ed i tuoi settaggi ',
  select_leverage: 'seleziona la leva',
  create: 'crea',
  select_account_type: 'seleziona il tipo di conto',
  select_currency: 'seleziona la valuta base',
  no_trading_account_found: 'nessun conto di trading trovato.',
  bankwire_notice:
    "Grazie per averci inviato I tuoi dati bancari. Registreremo I tuoi dati con la nostra banca.<br><br>Riceverai i dati del bonifico via email entro 24 ore insieme alla causale per il pagamento. Puoi usare questi dati per tutti I depositi futuri.<br><br><strong>IMPORTANTE:</strong>La causale di pagamento e'personalizzata per ciadcun cliente.Se non indicherai la causale di pagamento corretta non saremo in grado di accettare il tuo deposito.Terze parti non sono autorizzate ad utilizzare la tua stessa causale.",
  deposit: 'deposita',
  account_details: 'Dettagli conto',
  enter_fasapay_id: 'Per favore inserisci il tuo ID Fasapay',
  account_id: 'ID conto',
  continue: 'continua',
  // bankwire_details_notice: 'Our bank requires your bank details in order to process your deposit. Any deposits made via Wire Transfer will be returned to the same account from which you deposited.',
  bankwire_deposit_details_notice:
    'La nostra banca necessita di una conferma dei tuoi dati bancari per processare il tuo deposito. Tutti i depositi effettuati a mezzo bonifico verranno restituiti allo stesso conto usato per depositare.',
  bankwire_withdrawal_details_notice:
    'La nostra banca necessita di una conferma dei tuoi dati bancari per processare il tuo deposito. Tutti i prelievi effettuati a mezzo bonifico verranno restituiti allo stesso conto usato per depositare.',
  bankwire_verify_account_notice:
    '<p>Devi completare la verifica del tuo conto prima di poter depositare con bonifico bancario. Per favore<a href="{FSROOT_URL}upload-documents">carica I tuoi documenti</a></p>',
  bankwire_amount_label: 'Importo (deposito minimo {minDeposit})',
  bank_name: 'nome banca',
  full_name: 'nome completo',
  deposit_methods: 'metodi di pagamento',
  deposit_select_ta_p: 'Per favore seleziona il conto su cui vuoi depositare:',
  coming_soon: 'Prossimamente',
  amount: 'importo',
  proof_of_id: "Documento di identita'",
  proof_of_id_instructions: "Documento di identita'",
  documents_must_contain_all_of_the_following_details: 'I documenti devono riportare le seguenti imformazioni:',
  your_full_name: 'Nome completo',
  a_unique_id_number: 'Numero identificativo documento',
  your_birthdate: 'Data di nascita ',
  your_place_of_birth: 'Luogo di nascita',
  a_visible_photo: 'Foto',
  your_signature: 'Firma',
  your_nationality: "Nazionalita'",
  proof_of_residence_instructions: 'Per favore carica una bolletta o un estratto conto',
  your_residential_address: 'Il tuo indirizzo di residenza',
  date_of_issue: 'data di emissione',
  other: 'oltro',
  other_documents_instructions: 'Altri documenti che sono stati richiesti dal nostro ufficio verifica conti.',
  deposit_failed: "il deposito non e' andato a buon fine",
  deposit_successful: 'il deposito completato correttamente',
  already_logged_in: "sei gia' loggato",
  login: 'accesso',
  create_an_account: 'crea un conto',
  partner_clients: 'Partner - Clienti',
  trades: 'posizioni',
  client_id: 'ID cliente',
  trading_account: 'conto di trading',
  platform: 'piattaforma',
  order: 'ordine',
  pair: 'coppia',
  volume: 'volume',
  close_date: 'data di chiusura',
  commission: 'commissione',
  status: 'stato',
  total_commission_generated: 'totale commissioni generate',
  total_deposits: 'totale depositi',
  total_withdrawals: 'totale prelievi',
  date_joined: 'data di iscrizione',
  more: 'altro',
  banners: 'banners',
  partner_marketing_material: 'Partner - Materiale di marketing',
  partner_overview: 'Partner - generale',
  partner_payout: 'Partner - pagamenti',
  partner_payout_request_message: "la tua richiesta e' stata registrata",
  select_your_default_payment_option: "Seleziona la tua modalita' di pagamento preferita",
  beneficiary_name_on_account: 'Beneficiario (Nome del conto)',
  bank_address: 'Indirizzo della banca',
  sorty_code_if_applicable: 'Sort Code (se disponibile)',
  your_provider_email: 'La tua email {provider}',
  select: 'seleziona',
  next: 'avanti',
  please_confirm_your_bank_details: 'Per favore conferma I tuoi dati bancari:',
  bank: 'banca',
  sub_partners: 'Sub Partners',
  state: 'stato',
  date: 'data',
  internal_transfer_instructions:
    "Puoi trasferire fondi tra I tuoi conti.<br>Per favore inserisci l'importo che desideri trasferire e seleziona il conto di partenza e di arrivo dei fondi. <br> I trasferimenti interni vengono processati immediatamente.",
  transfer_complete: 'trasferimento completato',
  transfer_from: 'Trasferisci da',
  internal_transfer_processed_successfully: 'Trasferimento interno completato con successo.',
  external_transfer_processed_successfully: 'Trasferimento esterno completato con successo.',
  select_account: 'Seleziona conto',
  to: 'a',
  warning_currency_conversion_will_take_place: "attenzione: verra' effettuate la conversione di valuta",
  transfer: 'trasferimento',
  account: 'conto',
  currency: 'valuta',
  balance: 'saldo',
  equity: 'equity',
  download: 'download',
  launch: 'avvia',
  email: 'email',
  password: 'password',
  forgot: 'dimenticata',
  forgot_password: 'password dimenticata',
  risk_warning_footer:
    "Informativa sui rischi: il trading su prodotti a leva come Forex e CFDs potrebbe non essere adatto a tutti gli investitori per via dell'alto rischio a cui e' esposto il tuo capitale. Prima di fare trading, accertati di averne compreso a pieno i rischi, in considerazione dei tuoi obiettivi di investimento e livello di esperienza, e se necessario richiedi il parere indipendente di un esperto. Ti preghiamo di leggere<a href='{riskURL}'> l'informatva completa sui rischi</a>.",
  error_contact_support: "Si e' verificato un errore, ti preghiamo di contattare il servizio clienti.",
  type: 'tipo',
  funded: 'deposito effettuato',
  username: 'username',
  company_name: "nome dell'azienda",
  website: 'sito web',
  first_name: 'nome',
  last_name: 'cognome',
  date_of_birth: 'Data di nascita',
  gender: 'sesso',
  phone: 'recapito telefonico',
  dial_code: 'prefisso internazionale',
  country: 'Paese',
  address: 'indirizzo di residenza',
  year_moved_to_address: 'Da che anno risiedi a questo indirizzo',
  post_code: 'codice postale',
  selected_currency: 'valuta selezionata',
  january: 'gennaio',
  february: 'febbraio',
  march: 'marzo',
  april: 'aprile',
  may: 'maggio',
  june: 'giugno',
  july: 'luglio',
  august: 'agosto',
  september: 'settembre',
  october: 'ottobre',
  november: 'novembre',
  december: 'dicembre',
  already_have_an_account: "Hai gia' un conto attivo",
  invalid_request_login_required: 'Richiesta non valida, per favore effettua il login ',
  register_accounttype_account: 'registra un conto {account type}',
  client_type: 'topilogia di cliente',
  individual: 'persona fisica',
  company: 'azienda',
  company_information: 'informazioni aziendali',
  company_website: 'sito web aziendale',
  complete_live_registration: 'completa la registrazione live',
  title: 'titolo',
  confirm_password: 'conferma password',
  select_country: 'selezione il Paese',
  phone_number: 'numero di telefono',
  choose_trading_platform: 'scegli la piattaforma di trading',
  select_option: "scegli un'opzione",
  day: 'giorno',
  month: 'mese',
  year: 'anno',
  company_registration_information: "informazioni dell'azienda",
  date_of_registration: 'data di costituzione',
  select_nationality: "seleziona la nazionalita'",
  nationality: "nazionalita'",
  select_gender: 'seleziona il genere',
  male: 'uomo',
  female: 'donna',
  address_line: 'indirizzo',
  city_town: "citta'",
  state_province: 'stato/provincia',
  select_year: "seleziona l'anno",
  year_moved_to_current_address: "anno dal quale risiedi all'indirizzo corrente",
  company_shareholders_directors: 'soci e amministratori',
  number_of_shareholders: 'numero di soci',
  number_of_directors: 'numero di amministratori',
  shareholder: 'socio',
  financial_information: 'informazioni finanziarie',
  total_estimated_net_worth: 'Patrimionio netto stimato (€)?',
  less_than_amount: 'meno di {amount}',
  over_amount: "piu' di {amount}",
  total_estimated_annual_income: 'Fatturato annuale',
  employment_information: 'occupazione',
  employment_status: 'impiego attuale',
  employed: 'lavoratore dipendente',
  self_employed: 'lavoratore autonomo',
  retired: 'pensionato',
  student: 'studente',
  unemployed: 'disoccupato',
  source_of_income: 'fonte di reddito',
  employment: 'lavoro',
  inheritance: "eredita'",
  investment: 'investimenti',
  trading_experience: 'esperienza di trading',
  forex_cfds_and_other_instruments: 'forex, CFDs ed altri strumenti',
  yes: 'si',
  no: 'no',
  lose_capital_risk:
    "I prodotti derivati sono consoni ai miei obiettivi di investimento e propensione al rischio, e sono in grado di valutare il rischio implicito, compresa la possibilita' di perdere tutto il mio investimento iniziale.",
  prev_pro_qualifications: 'Ho una qualifica professionale pregressa e/o esperienza lavorativa nel settore finanziario',
  account_type: 'tipo di conto',
  choose_currency: 'scegli la valuta base',
  tos_with_link:
    "Confermo presa visione ed accettazione dell'informativa sulla privacy, informativa sui rischi, termini e condizioni del conto e contratto partner come mostrato <a target='blank' href='{URL}'>qui</a>",
  registration_successful: 'registrazione completata con successo',
  reset_password_invalid_link: "il tuo link di reset non e'valido, ti preghiamo di riprovare o di contattare il servizio clienti.",
  reset_account_password: 'resetta la password del tuo conto',
  choose_your_new_password: 'scegli una nuova password',
  reset_password: 'resetta la password',
  file_upload_failed_filename: "la richiesta di upload del file { filepath } non e' andata a buon fine.",
  withdrawal_request_success_message: 'richiesta di prelievo inserita correttamente',
  withdraw: 'prelievo',
  please_fill_the_following: 'ti preghiamo di compilare I seguenti campi',
  cancel: 'annulla',
  withdraw_select_ta_p: 'Seleziona il conto da cui prelevare:',
  free_margin_change_warning: 'Attenzione: prelievo dovrebbe essere effettuato sullo stesso mezzo di pagamento utilizzato per il deposito',
  you_need_an_ib_account_to_visit_this_page: 'Devi avere un conto IB per visualizzare questa pagina',
  no_permission_to_to_visit_this_page: 'Non sei autorizzato a visualizzare questa pagina',
  you_became_a_partner_successfully: 'Congratulazioni, ora sei un partner di EUROTRADER!',
  note_wallet_currency_conversion_partner:
    "Attenzione: la richiesta di adesione come partner modifichera' automaticamente la valuta base del tuo wallet a USD ed i fondi eventualmente presenti verranno convertiti in USD al tasso di cambio attuale!",
  upgraded_to_a_live_account_successfully: 'Aggiornamento ad un conto live effettuato con sucesso!',
  passwords_dont_match: 'Le password non coincidono',
  password_rules: 'Requisiti minimi: 1 lettera maiuscola, 1 minuscola e 1 numero (da 6 a 16 caratteri)',
  please_fill: 'Ti preghiamo di compilare',
  partner_verify_first_notice: 'Per diventare partner devi prima completare la verifica del tuo conto. Ti preghiamo di caricare I tuoi documenti<a href="upload-documents">qui</a>',
  only_currency_format_allowed: "L'unico formato accettato e' quello della valuta",
  please_enter_your_account_id: 'Per favore inserisci il tuo ID conto',
  min_deposit_with_bankwire_is_amount: "Il deposito minimo a mezzo bonifico bancario e' di {amount}",
  please_select_different_tas: 'Per favore seleziona conti diversi',
  you_need_to_accept_our_tos: 'Ti preghiamo di accettare I nostri termini e condizioni',
  phone_is_required: "Il numero di telefono e' obbligatorio",
  invalid_phone_number: 'invalid phone number',
  you_must_be_over_18: 'Numero di telefono non valido',
  year_is_required: 'Devi essere maggiorenne.',
  leave_page_question: 'Vuoi abbandonare la pagina?',
  registration_exit_notice: 'Non hai completato la registrazione. Vuoi abbandonare senza completarla?',
  internal_server_error_support: 'Errore interno del server. Per favore contatta il supporto clienti',
  please_fill_all_fields: 'Per favore completa tutti I campi',
  no_logs_found_for_this_client: 'Nessuno storico trovato per questo cliente',
  no_accounts_send: 'Nessu conto inviato',
  internal_server_error_try_again: "Errore interno del server. Per favore riprova piu' tardi",
  insufficient_balance: 'Saldo insufficiente',
  currency_conversion_connection_error: "Nessuna risposta dal server di conversione di valuta, ti preghiamo di riprovare o di contattare l'assistenza clienti.",
  currency_conversion_error: 'Errore nella conversiona di valuta, ti preghiamo di contattare il servizio clienti.',
  invalid_accounts: 'Conti non validi',
  withdrawal_unsuccessful_equity_message: "La richiesta di prelievo non e' andata a buon fine. L'equity del tuo conto non e' sufficiente {TAID}",
  withdrawal_failed_free_margin: 'Prelevamento non andato a buon fine. Ti preghiamo di verificare il tuo margine disponibile',
  pamm_copy_server_field_message: `Ti preghiamo di copiare e incollare l'indirizzo IP nel campo "server" nel tuo server MT4`,
  invalid_request: 'richiesta non valida',
  missing_shareholders_directors: 'Mancano i soci/amministratori',
  missing: 'Da completare',
  invalid_request_passwords_do_not_match: 'Richiesta non valida. Le password non coincidono',
  email_exists_message: "L'indirizzo email e' gia registrato, ti preghiamo di utilizzarne uno diverso.",
  your_payment_method_has_already_been_set: "Il tuo metodo di pagamento e' gia ' stato configurato. Ti preghiamo di contattare il servizio clienti.",
  payment_method_is_required_message: "Il metodo di pagamento e' obbligatorio. Ti preghiamo di riprovare o di contattare il servizio clienti",
  couldnt_find_your_account: 'Non siamo riusciti a trovare il tuo conto',
  ta_limit_error_message: 'Il tuo conto ha raggiunto i limite massimo{limit} di trading per {platform}.',
  error: 'Errore',
  account_created_successfully: 'Conto creato con successo',
  invalid_leverage: 'Leva non valida',
  insufficient_data_provided: 'I dati forniti non sono sufficienti',
  insufficient_data_provided_missing_field: 'I dati forniti non sono sufficienti. {field} non inserito.',
  invalid_amount: 'importo non valido',
  account_taid_doesnt_exist: 'Il conto {TAID} non esiste',
  withdrawal_unsuccessful_equity_taid: "Prelievo non andato a buon fine, l'equity del tuo conto trading non e' sufficiente {TAID}",
  withdrawal_unsuccessful_free_margin_taid: "Prelievo non andato a buon fine, il margine libero del tuo conto trading non e' sufficiente {TAID}",
  internal_server_error: 'Errore interno del server',
  deposit_failed_support: "Il deposito non e' andato a buon fine, ti preghiamo di contattare il servizio clienti.",
  upload_documents_instructions: "Ti preghiamo di inviare I seguenti documenti.<br>I file vengono accettati in formato PDF, JPG o PNG e non devono essere piu'grandi di 5 mb.",
  total_earned: 'totale guadagnato',
  total_paid: 'totale pagato',
  total_clients: 'totale clienti',
  total_sub_ibs: 'totale sub-Ibs',
  see_trading_accounts: 'visualizza conti di trading',
  see_trades: 'visualizza le operazioni',
  welcome_title_live: 'Grazie per aver aperto un conto con EUROTRADER!',
  welcome_title_demo: 'Grazie per aver aperto un conto demo con EUROTRADER!',
  welcome_title_ib: 'Grazie per aver aperto un conto Partner con EUROTRADER!',
  welcome_text_live:
    "<p>Al fine di verificare il tuo conto e poter cominciare a fare trading ti preghiamo di completare i seguenti step:</p><ul><li>Effettua il login nel tuo portale clienti EUROTRADERl</li><li>Carica i tuoi documenti</li><li>Fund your Effettua un deposito</li><li>Comincia a fare trading!</li></ul><p>Il nostro servizio clienti e' attivo 24/5, non esitare a contattarci <a href='{contactURL}' target='_blank'> qui </a></p>",
  welcome_text_demo:
    "<p>Al fine di verificare il tuo conto e poter cominciare a fare trading ti preghiamo di completare i seguenti step:</p><ul><li>scarica la piattaforma MT4<a href='{platformDownloadURL}'>qui</a></li><li>Testa le tue capacita' di trading e la nostravelocita' di esecuzione</li><li>Effettua il login nel tuo conto di trading e passa ad un conto live</li><li>Carica i tuoi documenti ed effettua il primo deposito</li><li>Fai trading sui maggiori mercati mondiali</li></ul><p>Il nostro servizio clienti e' attivo 24/5, non esitare a contattarci<a href='{contactURL}' target='_blank'>qui</a></p>",
  welcome_text_ib:
    "<p>Al fine di verificare il tuo conto Partner e ricevere il tuo referral link, ti preghiamo di completare i seguenti step:</p><ul><li>Effettua il login nel tuo portale clienti</li><li>carica i tuoi documenti</li><li>Visualizza il tuo referral link nelle sezioni 'generale' and 'strumenti di marketing'</li><li>Presenta i tuoi clienti e guadagna commissioni!</li></ul><p>Il nostro servizio clienti e' attivo 24/5, non esitare a contattarci <a href='{ contactURL }' target='_blank'>qui</a></p>",
  bankwire_passports_notice: "IMPORTANTE: E' richiesto il passaporto come prova di identita' per effettuare un bonifico bancario.",
  tracking_links: 'link di tracciamento',
  proof_of_residence: 'prova di residenza',
  login_to_your_account: 'accedi al tuo conto',
  register: 'registrati',
  open_demo_account: 'apri un conto demo',
  create_partner_account: 'crea un conto partner',
  ib_payout_msg_monthly_payment: 'I pagamenti vengono effettuati due volte al mese tramite il metodo da te scelto, il 15 ed il primo giorno lavorativo di ogni mese.',
  payout_selection_complete: "Il metodo di pagamento e' stato selezionato.",
  home: 'Pagina iniziale',
  about: 'Informazioni',
  account_types: 'tipi di conto',
  spreads: 'spreads',
  funding: 'come depositare',
  education: 'Formazione',
  contact: 'Contatto',
  forex_broker: 'broker forex',
  services_provided_by: 'Servizi finanziari offerti da Eurotrader Global Ltd',
  footer_certificate_eurotrader:
    'Eurotrade SA (Pty) Ltd (“Eurotrader”) is a subsidiary of Eurotrade RGB Holdings Ltd (HE367109) and is an authorized financial services provider, licensed and regulated by the Financial Sector Conduct Authority (FSCA) in South Africa with license number FSP <a href="https://www.fsca.co.za/Fais/Search_FSP.htm" style="color: #e04ef8; text-decoration: underline" target="_blank">44351</a> with registered address at 74 Walmer street, Sydenham, Johannesburg, 2192, South Africa.<br /><br /><!-- ‘Eurotrader’ is a registered brand of Eurotrade Investments RGB Ltd, a Cypriot Investment Firm (CIF) under the Registration Number HE317893, licensed and regulated by the Cyprus Securities and Exchange Commission (CySEC) under license 279/15 with registered address at 70, Kyrillou Loukareos Street, Kakos Premier Tower, 1st Floor, 4156 Limassol, Cyprus. Card processing will be completed by Eurotrade Investments RGB Ltd.<br /><br /> -->Eurotrader does not provide services to residents of certain jurisdictions including the USA, Iran, Canada, the Democratic Republic of Korea, Belgium, Japan, and is not intended for distribution to, or use by, any person in any country or jurisdiction where such distribution or use would be contrary to local law or regulation.<br /><br />Eurotrade SA (PTY) Ltd does not actively target EU clients.',
  footer_risk_warning:
    "Informativa sui rischi: il trading su prodotti a leva come Forex e CFDs potrebbe non essere adatto a tutti gli investitori per via dell'alto rischio a cui e' esposto il tuo capitale. Prima di fare trading, accertati di averne compreso a pieno i rischi, in considerazione dei tuoi obiettivi di investimento e livello di esperienza, e se necessario richiedi il parere indipendente di un esperto. Ti preghiamo di leggere <a href='{brokerURL}assets/pdf/risk-disclosure.pdf?v= {urlRandomString}'> l'informatva completa sui rischi</a>.",
  open_live_account: 'apri un conto live',
  not_registered_with_question: 'Non sei registrato con Eurotrader?',
  forgot_password_q: 'Password dimenticata?',
  pending_deposit_success: "Operazione effettuata con successo, il tuo deposito e' in approvazione.",
  your_card_will_be_charged_cny: "L'importo di <b>{amount}</b> CNY verra' addebitato sulla tua carta",
  currency_conversion_info: 'Informazioni di conversione valuta',
  min_deposit_is_amount: "il deposito minimo e' {amount}",
  min_transfer_is_amount: "Il trasferimento minimo e' {amount}",
  local_depositor: 'Depositante locale',
  converted_amount: 'importo convertito',
  from_currency: 'da valuta',
  to_currency: 'a valuta',
  reference_id: 'riferimento operazione',
  from_account: 'dal conto',
  to_account: 'al conto',
  from_date: 'dalla data',
  to_date: 'alla data',
  target_account_id: 'ID del conto in oggetto',
  wallet: 'wallet',
  received: 'ricevuto',
  send: 'invia',
  sender_not_a_transfer_account: "Il mittente non e' un depositante locale",
  withdrawal_failed_support: "Il prelievo non e' andato a buon fine, ti preghiamo di contattare l'assistenza clienti.",
  clear: 'cancella',
  transfer_completed_successfully: "il trasferimento e' stato completato corrtettamente",
  receive: 'ricevi',
  view_trades: 'visualizza operazioni',
  your_provider_account_number: 'Il tuo conto {provider}',
  your_bitcoin_address: 'Il tuo indirizzo bitcoin',
  your_crypto_address: 'Il tuo indirizzo {crypto}',
  destination_tag: 'Etichetta di destinazione',
  change_trading_account_password: 'cambia la password del conto trading',
  your_card_will_be_charged_thb: "L'importo di <b>{amount}</b> THB verra' addebitato sulla tua carta",
  dashboard: 'pannello di controllo',
  sent: 'inviato',
  client_state_approved: 'approvato',
  client_state_pending: 'in sospeso',
  open_trades: 'operazioni aperte',
  trade_history: 'storico operazioni',
  search_trades: 'ricerca operazioni',
  trade_no: "numero dell'operazione",
  symbol: 'simbolo',
  open_price: 'prezzo di apertura',
  close_price: 'prezzo di chiusura',
  datetime: 'giorno e ora',
  my_bonuses: 'Bonus',
  bonus: 'bonus',
  conversion_progress: 'stato della conversione',
  front_of_id: "fronte documento di identita'",
  back_of_id: "retro documento di identita'",
  include_account_in_bonus_program: 'Vuoi ricevere il bonus del 111%?',
  invest_under_master_account: 'investi sotto un master conta',
  i_accept_the_terms_of_service: 'Accetto termini e condizioni del servizio',
  pamm_master_locks_withdrawals: '[questo master pamm non consente prelievi quando ci sono operazioni aperte]',
  open_p_l: 'profitto/perdita corrente',
  p_l: 'profitti e perdite',
  gains_prc: '% guadagni',
  max_drawdown: 'perdita massima',
  bonus_tos_with_link: 'Confermo presa visione ed accettazione dei termini e condizioni <a target="_blank" href="{URL}"> del bonus 111%</a>.',
  all_time: "dall'inizio",
  last_month: 'ultimo mese',
  last_week: 'ultima settimana',
  last_3_days: 'ultimi tre giorni',
  monthly_avg: 'media mensile',
  profit: 'profitto',
  create_and_attach: 'crea e allega',
  attach: 'allega',
  create_and_attach_new_pamm_account: 'crea e allega nuovo conto pamm',
  select_a_pamm_account_to_attach: 'seleziona un conto pamm da allegare',
  enter_private_code: 'inserisci un codice privato',
  private_code: 'codice privato',
  investor_link: 'Link investitore',
  i_accept_the_lpoa: 'accetto il la delega ad operare limitata',
  invest: 'investi',
  view_graph: 'visualizza il grafico',
  name: 'nome',
  search: 'cerca',
  partners: 'partners',
  reject_withdrawls_during_open_trades: 'Rifiuta i prelevamenti quando ci sono operazioni aperte',
  private_master_account: 'conto master privato',
  minimum_deposit: 'deposito minimo',
  performance_fee: 'commissione sulla parformance',
  display_name: 'visualizza nome',
  new_master_account: 'nuovo conto master',
  pamm_statistics: 'statistiche pamm',
  pamm: 'pamm',
  volume_traded: 'volume tradato',
  apply_date_range: 'applica intervallo di date',
  pamm_master_locks_deposits: '[questa pamm non permette depositi quando ci sono posizioni aperte]',

  // new with vue
  bitcoin: 'Bitcoin',
  register_live_account: 'registra un conto live',
  register_partner_account: 'registra un conto partner',
  register_demo_account: 'registra conto demo',
  risk_disclosure: 'informativa sui rischi',
  address_line_2: 'seconda riga di indirizzo',
  skype_id: 'ID skype',
  password_rules_extended:
    'La password deve contenere almeno 1 lettera maiuscola, 1 minuscola, 1 numero ed un carattere speciale. La lunghezza della password deve essere compresa tra 8 e 16 caratteri.',
  login_information: 'Informazioni di login',
  director: 'amministratore',
  pmethod_visa_mastercard: 'VISA/MASTERCARD',
  pmethod_visa_mastercard_alternative: 'VISA/MASTERCARD.',
  pmethod_bitcoin: 'BITCOIN',
  pmethod_bankwire: 'Bonifico bancario',
  pmethod_fasapay: 'Fasapay',
  pmethod_ideal: 'ideal',
  pmethod_instant_bank_transfer: 'Bonifico Bancario Istantaneo',
  pmethod_jeton: 'Jeton',
  pmethod_jeton_wallet: 'Jeton Wallet',
  pmethod_my_pay: 'MyPay',
  pmethod_neteller: 'NETELLER',
  pmethod_vload: 'VLOAD',
  pmethod_paykasa: 'Paykasa',
  pmethod_skrill: 'Skrill',
  pmethod_sofort: 'Sofort',
  pmethod_koalapay: 'KoalaPay',
  pmethod_cup: 'CUP',
  pmethod_lydiax: 'Crypto',
  pmethod_safecharge: 'SafeCharge',
  pmethod_trustly: 'Trustly - Bank Wire',
  field_min_currency_value: "Il valore del {field} campo deve essere {min} o piu' alto.",
  method_deposit: 'deposito {method}',
  method_deposit_status: 'stato del deposito {method}',
  quick_menu: 'menu veloce',
  details: 'dettagli',
  date_from: 'data da',
  date_to: 'data a ',
  from: 'da',
  forgot_password_form_instruction: 'Ti preghiamo di inserire il tuo indirizzo email qui sotto. Riceverai una email con il link per resettare la tua password',
  forgot_password_submit_success_message: "Ti abbiamo inviato il link per resettare la tua password via email all'indirizzo({email}), cliccla sul link per resettare la password.",
  password_reset_successfully: "La tua password e' stata modificata correttamente.",
  password_too_week_or_mismatch: "La password non e' abbastanza sicura o le due password inserite non coincidono.",
  withdrawals_credit_card_remaining_amount_message: 'Al fine di prelevare con altri mezzi di pagamento devi prima prelevare {amount} sulla tua carta.',
  withdrawals_credit_card_refund_policy_message: "I fornitori di carte di credito permettono solo di prelevare l'importo totale che hai depositato sulla stessa carta.",
  withdrawals_amount_withdrawable_message:
    "Un totale di {amount} puo' essere prelevato ed inviato sulla tua carta, qualsiasi importo eccedente deve essere prelevato con un metodo di pagamenti diverso.",
  country_blocked_for_this_method: "Questo meodo di pagamento non e'disponibile nel tuo Paese",
  copied_text_successfully: 'copiato {text} correttamente',
  choose_wallet_currency: 'Scegli la valuta del wallet',
  pamm_master_account_created_successfully: 'Conto master PAMM creato con successo!',
  or_account_no_for_uk: 'oppure Numero di Conto (per clienti UK)',
  issue_date: 'Data di emissione',
  expiry_date: 'Data di scadenza',
  full_copy_of_the_document: 'Copia del documento dove tutti I 4 angoli siano visibili',
  recent_date: "Data recente (non piu' vecchia di 3 mesi)",
  your_physical_address: "Il tuo indirizzo di residenza, corrispondente all'indirizzo che hai usato quando hai registrato il conto ",
  must_be_a_utility_bill: "Deve essere una bolletta utenza domestica (elettricita', acqua, telefono, gas/energia, rifiuti) o un estratto conto",
  for_further_info_attach: "**Ti preghiamo di inviare ulteriore documentazione via email all'indirizzo backoffice @eurotrader.com ",
  banners_ad_blocker_notice: 'Se hai problemi nella visualizzazione dei banners qui sotto, per favore disabilita il tuo ad-blocker',
  transfer_out: 'trasferisci fuori',
  transfer_in: 'trasferisci dentro',
  done: 'fatto',
  not_required: 'non richiesto',
  wallet_balance: 'saldo del wallet:',
  must_agree_terms: 'Devi accettare I Termini e Condizioni per poter creare un conto',
  select_payment_method: 'seleziona il metodo di pagamenti',
  islamic_account: 'Conto Islamico',
  islamic_documents_instructions: 'Prova di fede/religione dalla moschea',
  card_number: 'numero della carta',
  expiry: 'Scadenza',
  redeem: 'riscattare',
  must_be_multiple_of_10: 'Il valore deve essere un multiplo di 10',
  select_starting_balance: 'seleziona il saldo di partenza',
  business_name: 'nome del business',
  business_bank_wire_instructions: 'istruzioni bonifico bancario business',

  error_request_failed: 'Errore:  richiesta non completata',
  error_no_user_with_this_email: 'Errore: non abbiamo trovato alcun conto associato a questo indirizzo email ',
  error_too_many_password_reset_requests: 'Errore:  troppe richieste di modifica della password',
  error_expired_or_invalid_request: 'Errore: richiesta non valida o scaduta',
  error_insufficient_wallet_balance: 'Errore: fondi insufficienti nel wallet',
  error_insufficient_balance_or_equity: 'Errore: saldo o equity insufficiente',
  error_pamm_master_deposit: "Non e' possibile depositare nel conto PAMM master",
  error_pamm_master_withdrawal: "Non e' possibile prelevare dal conto master PAMM",
  error_pamm_master_locked_deposits: 'Respinto: il master del conto PAMM respinge i depositi quando ci sono operazioni aperte',
  error_pamm_master_locked_withdrawals: "Respinto: il deposito e' inferiore al minimo stabilito per il master PAMM",
  error_pamm_master_minimum_deposit: "Respinto: il deposito e' inferiore al minimo stabilito per il master PAMM",
  error_live_account_already: "Il tuo conto e' gia' un conto live",
  error_min_balance_required_is: "Il saldo minimo richiesto per il conto {TAAccountType}({TAID}) e' di {min},{currency}",
  error_transfer_same_wallet: "Non e' possibile trasferirire da wallet a wallet",
  error_transfer_same_trading_account: "Non e' possibile trasferire da e verso lo stesso conto di trading",
  error_no_deposit_bonus_account_deposit_restricted: 'Non sono consentiti depositi su conti di tipo "Bonus senza deposito".',
  error_no_deposit_bonus_base_amount_withdrawal: '',
  error_no_deposit_bonus_withdraw_profit_requirement_not_met: '',
  error_no_deposit_bonus_withdraw_exceeds_max_withdrawable_profit: '',
  upgrade_required_for_live_ta: "E' necessario avere un conto live verificato prima di poter aprire un conto di trading live",
  error_wallet_currency_not_allowed_for_psp: 'Questo metodo di pagamento non supporta la valuta del wallet',
  error_invalid_or_expired_otp: "Errore:  la OTP fornita non e' valida o e' scaduta",
  error_max_confirmo_withdrawal_exceeded: "Errore: il prelievo massimo richiedibile a mezzo bonifico e' 20000 EUR/USD",
  error_max_anual_vload_withdrawal_exceeded: "Errore: L'importo annuale massimo prevelbile tramite VLoad e' stato superato",

  // Check for islamic trading account (temporarily disabled)
  is_islamic_acc_message: 'Per richiedere un conto Islamico ti preghiamo di inviare una richiesta via email a backoffice@eurotrader.com.',
  error_invalid_voucher: "Errore: voucher Vload non valido o gia' riscattato ",
  error_blocked_voucher: "Errore: il voucher Vload e' bloccato per sospetta frode",
  error_voucher_data_mismatch: "Errore: il voucher Vload e' stato rifiutato perche' i dati del conto non corrispondono",
  error_vload_voucher_below_minimum: "Errore: il valore del voucher Vload e' al di sotto del deposito minimo.",
  my_bank_has_a_swift_code: 'La mia banca ha un codice swift',
  my_bank_does_not_have_a_swift_code: 'La mia banca non ha un codice swift',
  bank_not_in_swift_network_instructions:
    "Se la tua banca non e' un membro dello SWIFT, ti preghiamo di inviarci le seguenti informazioni sulla banca corrispondente utilizzata dalla tua banca per bonifici internazionali:",
  correspondent_bank_name: 'Nome della banca corrispondente',
  correspondent_bank_city: "Citta' della banca corrispondente",
  correspondent_bank_swift: 'Swift della banca corrispondente',
  identity_card: 'Carta d\'identità',

  // New document upload strings
  proof_of_cc: 'Prova della carta di debito/credito',
  front_of_cc: 'Fronte della carta',
  back_of_cc: 'retro della carta',
  proof_of_cc_instructions: 'Per favore carica la tua carta di debito o credito.',
  add_document: 'Aggiungi un documento (facoltativo)',
  cc_requirements_1: 'Copia del documento dove tutti I 4 angoli siano visibili',
  cc_requirements_2:
    "Nome sulla carta:  la cart che userai dovra' essere esclusivamente a tuo nome.Qualsiasi deposito effettuato con carte intestate a terzi verra ' immediatamento restituito.",
  cc_requirements_3: 'Data di scadenza: non meno di tre mesi.',
  cc_requirements_4:
    'Numero della carta: I sei numeri centrali della carta devno essere coperti con un pezzo di carta. Solo I primi 6 e gli ultimi 4 numeri devono essere visibili.',
  cc_back_requirements_5: 'Codice CVV: per favore copri il codice CVV con un pezzo di carta',
  cc_back_requirements_6: 'La carta deve essere firmata.',
  click_to_add_another_document: 'Clicca qui sopra per aggiungere un altro spazio per caricare documenti',
  add_up_to_4_extra_documents: 'Puoi aggiungere fino a 4 documenti aggiuntivi',
  add_up_to_10_extra_documents: 'Puoi aggiungere fino a 10 documenti aggiuntivi',
  complete_profile: 'Completa il profilo',
  document_received: "Abbiamo ricevuto il tuo documento, il nostro team lo esaminera' alpiu ' presto.",
  document_req_color: 'I documenti devono essere a colori',
  internal_error: "Si e' verificato un errore interno",
  please_enter_your_email: 'per favore inserisci il tuo indirizzo email',
  do_you_want_to_transform_your_trading: 'Vuoi trasformare il tuo trading?',
  reset_your_password_to_transfer_your_account: 'Resetta la tua password per trasferire il tuo conto.',
  reset_your_old_password: 'Resetta la tua vecchia password',
  reset_password_desc:
    'A causa di in trasferimento di sistema ti preghiamo di aggiornare la tua password. Per favore compila il modulo sottostante per ricevere il link di reset password.',
  eurotrader_login: 'Eurotrader login | Entra nel trading hub per portare il tuo trading ad un altro livello',
  your_email_is_verified: "la tua email e' gia' verificata.",
  click_here_to_login: 'Clicca qui per effettuare il login',
  success_email_verified: "La tua email e' stata verificata con successo!",
  your_link_expired: "il tuo link e' scaduto.",
  click_here_to_request_verification_email: 'Clicca qui per richiedere una nuova email di verifica.',
  a_new_verification_link_send: 'Ti abbiamo un nuovo link di verifica al tuo indirizzo email.',
  invalid_request_please_check_your_link: 'Richiesta non valida. Ti preghiamo di controllare che il link sia corretto e di riprovare.',
  invalid_verification_code: 'Codice di verifica non valido',
  please_enter_amount: "Per favore inserisci l'importo che vuoi depositare",
  bankwire_company_desc:
    "<p>Se hai un conto corrente bancario aziendale e vuoi inviare un bonifico bancario registrando il tuo conto aziendale con noi, ti preghiamo di inviare I seguenti documenti via email al' 'indirizzo backoffice@eurotrader.com</p><ul><li>Visura Camreale</li><li>Atto costitutivo e statuto, se applicabili</li><li>Documento di identita' e prova di residenza di tutti i soci ed amministratori </li><li>prova di residenza relativa all'azienda</li></ul><p>Qualsiasi altro documento che attesti che le suddette informazioni non possano essere fornite in tale formato.</p>",
  bankwire_noncompany_desc:
    "<p>Questo ti fara' effettuare il logout dalla tua area personale e verrai reindirizzato alla nostrapagina gi registrazione per un conto aziendale. </p><p>Vuoi procedere?</p>",
  please_enter_card_detail_and_amount: "PER FAVORE INSERISCI IL NUMERO DELLA CARTA E L'IMPORTO DEL DEPOSITO",
  important: 'IMPORTANTE',
  please_note_that_the_maximum_deposit_amount: "Attenzione: l'importo di deposito massimo e' di $1000 per carta",
  city: "Citta'",
  zip: 'Codice postale',
  please_note_that_after_three_unsuccessful_attempts: "*Attenzione: dopo tre tentativi di deposito falliti l'ozione di pagamento VISA/MASTERCARD verra' disabilitata per 24 ore.",
  epay_pro_desc:
    "<p>Gentile  tradee<br><br>Sfortunatamente, a causa di alcuni problemi tecnici e restrizioni, i depositi a mezzo Carta di Credito saranno temporaneamente disabilitati dal nostro provider Epaypro.<br><br>Visa & Mastercard saranno disabilitati a mezzanotte 23:00GMT del 04/04/2018. Di conseguenza, i depositi saranno temporaneamente disabilitati. Sebbene il nostro provider non ci ha fornito una indicazione circa la durata del disservizio, stiamo lavorando per offfire una alternativa al piu' presto possibile. <br> <br> Stiamo lavorando con i nostri providers per risolvere i problemi correnti, in modo che in futuro possiamo processare i pagamenti senza alcun ritardo. <br> <br> In caso di necessita ' non esitare a contattare il nostro servizio clienti.</p>",
  provider_redirect: 'Sarai reindirizzato a {provider}',
  lydiax_note: "Il deposito minimo e' 30 EUR/USD",
  lydiax_note1:
    "Se depositi meno del controvalore di 30 EUR/USD in crytpovalute, dovrai inviare una email a backoffice@eurotrader.com e richiedere un rimborso, fornendo l' indirizzo {crypto} a cui vuoi che sia inviato.",
  lydiax_note2:
    "Per favore inserisci l'importo di {crypto} che vuoi depositare e visualizza una stima dell'importo convertito. Ti preghiamo di ricordare che i prezzi correnti sono validi sono nel momento in cui sono stati richiesti e cambiano continuamente.",
  lydiax_note3: 'Creeremo un indirizzo da utilizzare per il deposito.',
  lydiax_note4: 'Ti preghiamo di utilizzare il seguente indirizzo per depositare {crypto}.',
  lydiax_note5: "Da ora in avanti, questo indirizzo esclusivo sara' utilizzato per I tuoi depositi in {crypto}.",
  lydiax_required_address: 'Se il tuo wallet richiede indirizzo e tag separatamente, ti preghiamo di usare:',
  tag: 'Tag',
  lydiax_enter_deposit: 'PER FAVORE INSERISCI IN QUALE CRYPTOVALUTA VUOI DEPSITARE',
  create_address: 'Crea indirizzo',
  please_note: 'Nota bene:',
  price_estimate: 'Stima prezzo:',
  check_price: 'Controlla il prezzo',
  vload_please_enter_voucher: 'TI PREGHIAMO DI INSERIRE IL PIN DEL TUO VOUCHER VLOAD',
  vload_minimum: "<p>(Il valore minimo accettato per un voucher e' <b>50</b> EUR or USD!)</p>",
  vload_vouchers: 'Ho bisogno di acquistare vouchers Vload',
  vload_note: "Effettua un pagamento senza problemi con Visa/Mastercard o con bonifico bancario<br/>Scopri di piu' su Vload o acquista un voucher [EUR/USD] su vload.expert.",
  vload_note1: 'Al fine di poter depositare con Vload il tuo conto deve essere approvato!',
  reason: 'Motivo:',
  attempts: 'Tentativo {attempts} of {maxAttempts},',
  two_more_remaining: 'due (2) tentativi rimasti',
  one_more_remaining: 'Solo UN (1) tentativo rimasto',
  please_contact_bank: `Nota bene: la tua banca potrebbe applicare una commissione aggiuntiva al deposito per via della transazione internazionale. Si tratta normalmente di una commissione contenuta, ma varia da banca a baanca.<br><br>Questa transazione con carta di credito apparira' sul tuo estratto conto come "Tech Savy Billing", "Business Billing" o "Business Media Building".`,
  you_can_try: 'Puoi riprovare',
  here: 'qui',
  safe_charged_success_message: "Il tuo deposito verra' processato dal nostro backoffice nei prossimi due giorni lavorativi.",
  thank_you: 'Grazie!',
  your_deposit_successful: "Il tuo deposito e' andato a buon fine",
  card_redirect: 'Verrai reindirizzato per inserire i tuoi dati personali e della carta di credito.',
  bank_wire_withdrawal_note:
    "In caso un bonifico bancario venga respinto dalla banca ricevente a causa di dati errati forniti dal cliente, le spese amministrative applicate dalla banca verranno dedotte dall'importo prelevato dal cliente prima di riaccreditare il wallet del cliente.",
  please_enter_amount_withdraw: "Ti preghiamo di inserire l'importo che vuoi prelevare",
  bitcoin_note: "Ti preghiamo di inserire il tuo indirizzo bitcoin e l'importo che vuoi prelevare.",
  otp: 'Password "usa e getta" (OTP)',
  otp_send_email: 'Invia la OTP via email',
  otp_additional_text: "La OTP qui sopra e' dedicata alla richiesta di prelevamento Bitcoin corrente",
  otp_new_password: 'Ti abbiamo inviato una nuova password "usa e getta" (OTP) via email',
  otp_error: 'Errore - invio OTP fallito',
  lydiax_withdrawal_note:
    "Ti preghiamo di inserire l'importo in {currency) che vuoi prelevare per visualizzare una stima dei {crypto} che riceverai. Attenzione: I seguenti prezzi sono validi solo al momento della richiesta e possono variare in qualsiasi momento.",
  enter_currency_amount: "Inserisci l'importo in {currency} per verificare la stima",
  lydiax_withdrawal_additional_note: "La OTP qui sopra e' dedicata alla richiesta di prelevamento Crypto corrente",
  estimated: 'Stima:',
  please_enter_your_crypto_address: "Ti preghiamo di inserire il tuo indirizzo {crypto} e l'importo che vuoi prelevare",
  select_cryptocurrency: 'Seleziona cryptovaluta',
  request_amount: 'Importo addebitato (commissioni incluse)',
  amount_changes: 'Operazione fallita! La tua richiesta non era valida.',
  operation_failed: "Operazione fallita! Si e' verificato un errore nel processare la tua richiesta.",
  operation_failed_error: "Operazione fallita! Si e' verificato un errore nel processare la tua richiesta.",
  are_you_sure_create_master: 'Sei sicuro di voler creare un nuovo conto e collegarlo a questo master?',
  are_you_sure_attach_selected_account_to_master: 'Sei sicuro di voler e collegare il conto selezionato a questo master?',
  change_password_desc:
    "<strong>*</strong>Questa modifica password non influenzera' le password dei tuoi conti di trading. Ti preghiamo di visitare<strong>Lista conti</strong> per cambiare le passwords dei tuoi conti di trading, utilizzando l'opzione</strong>sotto l'icona a forma di ingranaggio.",
  client_assessment: 'VALUTAZIONE DEL CLIENTE',
  select_answer: 'Seleziona una risposta…',
  declarations: 'DICHIARAZIONI',
  complele_profile_desc: "Sei attualmente, o sei stato in passato, coinvolto in attivita' criminali o hai accuse penali in corso?",
  complete_profile_desc1:
    "Sei una Persona Politicamente Esposta, o qualcuno dei tuoi parenti o socilo e'?  Le Persone Politicamente Esposte sono coloro che hanno rivestito funzioni pubbliche di rilievo entro gli ultimi 12 mesi, per esempio Capo di Stato o del governo, politici, governatori, giudici e ufficiali militari, amministratori di aziende a partecipazione statale, importanti politici di partito.",
  are_you_us_citizen: 'Sei un cittadino o risiedi negli U.S.A. ai fini fiscali?',
  please_check_forms_errors: 'Ti preghiamo di ricontrollare il modulo per errori!',
  profile_succesfully_completed: 'Profilo completato con successo',
  please_select_country: 'Ti preghiamo di selezionare il tuo Paese',
  set_country: 'Imposta il Paese',
  empty_country_code: 'Codice Paese vuoto, ti preghiamo di fare un refresh della pagina e riprovare.',
  invalid_country_code: 'Codice Paese non valido, ti preghiamo di fare un refresh della pagina e riprovare.',
  individual_company: 'SEI UNA PERSONA FISICA O UNA AZIENDA?',
  prev: 'PRECEDENTE',
  previous: 'PRECEDENTE',
  complete: 'COMPLETA',
  please_select_an_option: 'Seleziona un opzione per ogni campo!',
  swap: 'swap',
  buy: 'buy',
  sell: 'sell',
  sums: 'sums',
  net_total: 'totali',
  deposit_page_desc:
    "<p class='has-text-white is-size-5-desktop is-size-6-tablet is-size-6-mobile has-text-weight-bold' >Registrati adesso</p><p class='is-size-1-desktop is-size-2-tablet is-size-3-mobile has-text-weight-bold vload-promo-large-text'>e ottieni <span class='has-text-white has-text-weight-bold'> un eVoucher del valore di</span><br/> 10 EUR/ USD<br/></p>",
  deposit_page_desc1: "Questo bonus eVaucher di 10 EUR/USDsara' attivato una volta che hai",
  create_new_account: 'Creato un nuovo conto',
  successfully_purchase_vload: 'acquistato e utilizzato un eVoucher Vload di qualsiasi importo',
  upgrade_to_tier_2: 'fai la promozione al lilvello 2',
  register_now: 'REGISTRATI ADESSO',
  back: 'INDIETRO',
  my_card_desc: 'Qui puoi vedere tutte le carte che hai usato per I pagamenti e lo stato corrente nel nostro sistema.',
  you_have_no_card: 'Bnon hai ancora effettuato depositi con carta.',
  card_no: 'Numero carta',
  last_used: "Usata l'ultima volta",
  risk_warning: 'INFORMATIVA SUI RISCHI',
  upload_documents_note: 'Se desideri effettuare un deposito con Carta, per favore carica i seguenti documenti aggiuntivi per revisione ed approvazione.',
  please_select_your_country: 'Per favore seleziona prima il Paese',
  add_another_document: 'Aggiungi un altro documento',
  drop_files_upload: 'Trascina i documenti qui per caricarli',
  date_until: 'Data fino a',
  copy: 'Copia',
  cvv: 'CVV',
  please_enter_crypto_amount: "Inserisci l'importo in {crypto}",
  vload_pin: 'Pin Vload',
  deposit_info: `Si sta verificando un problema tecnico temporaneo con il fornitore dei servizi di pagamento, pertanto i depositi a mezzo Visa/Mastercard non sono al momento disponibili. In alternativa, se desideri depositare con Visa/Mastercard puoi scegliere l'opzione "Vload"`,
  id: 'ID',
  pamm_modal_error: `I dati inseriti nel campo "Nome" non sono validi. Per favore non lasciare il campo vuoto e non inserire piu'di 32 caratteri`,
  pamm_modal_error1: "Il dato inserito nel campo Deposito Minimo non e'valido.Per favore digita un numero intero positivo al di sotto di 1.000.000",
  error_missing_required_field: 'Errore, campo obbligatorio non compilato',
  page_not_found: 'PAGINA NON TROVATA',
  new_version_note: "E' DISPONIBILE UNA NUOVA VERSIONE, PER FAVORE CLICCA QUI PER AGGIORNARE",
  new_version_note1: "Aluna funzionalita' potrebbero non essere disponibili fino a quando non aggiorni la pagina",
  records: 'Registrare',
  client: '',
  commission_amount: '',
  tier_name: '',
  trades_completed: '',
  bitpace_network_warning_BTC:
    "Questo indirizzo e' esclusivamente per depositi in Bitcoin. Attenzione: NON utilizzare alcun network diverso da BTC per la transazione, o i fondi potrebbero essere irrimediabilmente persi.",
  bitpace_network_warning_LTC:
    "Questo indirizzo e' esclusivamente per depositi in Litecoin. Attenzione: NON utilizzare alcun network diverso da LTC per la transazione, o i fondi potrebbero essere irrimediabilmente persi.",
  bitpace_network_warning_XRP:
    "Questo indirizzo e' esclusivamente per depositi in Ripple. Attenzione: NON utilizzare alcun network diverso da XRP per la transazione, o i fondi potrebbero essere irrimediabilmente persi.",
  bitpace_network_warning_BCH:
    "Questo indirizzo e' esclusivamente per depositi in Bitcoin Cash. Attenzione: NON utilizzare alcun network diverso da BCH per la transazione, o i fondi potrebbero essere irrimediabilmente persi.",
  bitpace_network_warning_USDT:
    'Si prega di utilizzare unicamente i network Ethereum ERC20 o Tron (TRC20) per la transazione. Utilizzare un netowrk diverso potrebbe comportare che i fondi  fondi vengano essere irrimediabilmente persi. NON utilizzare BSC, BEP20, BEP-2 o altri network.',
  bitpace_network_warning_USDC:
    'Si prega di utilizzare unicamente i network Ethereum ERC20 o Tron (TRC20) per la transazione. Utilizzare un netowrk diverso potrebbe comportare che i fondi  fondi vengano essere irrimediabilmente persi. NON utilizzare BSC, BEP20, BEP-2 o altri network.',
  bitpace_network_warning_TRX:
    'Please use TRON (TRC20) network only. Your deposit will be lost and unrecoverable if you do not use the TRON network. Please do not send funds via BSC, BEP20, BEP-2 or other networks.',
  bitpace_network_warning_LINK:
    'Si prega di utilizzare unicamente i network Ethereum ERC20 per la transazione. Utilizzare un netowrk diverso potrebbe comportare che i fondi  fondi vengano essere irrimediabilmente persi. NON utilizzare TRC, BSC, BEP20, BEP-2 o altri network.',

  // new translations
  secure_id: 'ID sicuro',
  metatrader_web_client: 'client web metatrader',
  sort_code: 'Codice postale (per i clienti del Regno Unito)',
  page_title_partner: 'Diventa un partner | Eurotrader',
  client_state_incomplete: 'incompleto',
  i_am_over_18: 'Dichiaro di avere più di 18 (diciotto) anni per aprire questo Conto.',
  pmethod_powercash: 'PowerCash',
  pmethod_astropay: 'AstroPay',
  pmethod_payneteasy: 'Payneteasy',
  content_ad_blocker_notice: 'Se avete problemi a visualizzare il client web, disattivate il vostro ad-blocker.',
  please_check_the_box: 'Selezionare la casella sottostante.',
  must_be_over_18: 'Per iscriversi è necessario avere più di 18 anni.',
  shareholders_must_be_over_18: 'Per iscriversi, gli azionisti devono avere più di 18 anni.',
  directors_must_be_over_18: 'I direttori devono avere più di 18 anni per iscriversi.',
  edata_success_note:
    'Si prega di notare che potrebbe esserci una commissione aggiuntiva sul deposito, addebitata dalla banca emittente a causa della transazione internazionale. Si tratta di una commissione di modesta entità, ma che varia da banca a banca. <br><br>Questa transazione con carta di credito apparirà sull\'estratto conto come "Fatturazione Tech Savvy", "Fatturazione Business" o "Fatturazione Business Media".',
  gateway: "porta d'ingresso",
  account_no: 'Numero di conto',
  routing_no: 'Numero di instradamento',
  train_up: 'ALLENAMENTO.',
  trade_up: 'TRADE UP.',
  train_text_1: 'Siete pronti a investire nel vostro futuro?',
  train_text_2: "Iniziate con un conto demo senza rischi e con l'accesso alle risorse didattiche di Eurotrader Academy.",
  train_list_item_1: 'Esercitarsi nel trading in un ambiente simulato.',
  train_list_item_2: "Ottenere l'accesso alle migliori risorse di apprendimento.",
  train_list_item_3: 'Entrate a far parte della comunità Eurotrader.',
  train_list_item_4: 'Ricordate: niente da perdere, tutto da guadagnare.',
  form_title_1: 'ESERCITARSI CON',
  form_title_2: 'TUA',
  form_title_3: 'Conto demo',
  form_subtitle: 'E accedere alle risorse di apprendimento',
  region: 'Regione',
  wallet_currency: 'Valuta del portafoglio',
  select_currency_label: 'Valuta del conto demo',
  join: 'unirsi',
  demo_account: 'Conto demo',
  page_title_demo: 'Aprire un conto demo | Eurotrader',
  title_404: 'EHI, SOLDI, SONO A CASA!',
  text_line_1_404: "Cosa? Non c'è nessuno che vi aiuti a investire nel vostro futuro?",
  text_line_2_404: 'Torniamo a casa e mostriamo ai tuoi soldi di che pasta sei fatto.',
  button_404: 'TORNA INDIETRO',
  remember_me: 'Ricordati di me',
  risk_sentence: 'Per sapere come utilizziamo i vostri dati, consultate il nostro sito web',
  video_courses: 'Corsi video',
  ebooks: 'Libri elettronici',
  knowledge_and_experience: 'CONOSCENZA ED ESPERIENZA',
  economic_profile: 'PROFILO ECONOMICO',
  product_governance: 'GOVERNANCE DEL PRODOTTO',
  select_an_answer: 'Selezionare una risposta',
  declarations_q1: 'Siete attualmente o siete mai stati coinvolti in attività criminali o ci sono accuse penali pendenti contro di voi in tribunale?',
  declarations_q2:
    'Voi, un vostro parente o un vostro stretto collaboratore siete una persona politicamente esposta? Le persone politicamente esposte sono le persone fisiche che sono o sono state incaricate di importanti funzioni pubbliche negli ultimi 12 mesi, ossia capi di Stato o di governo, politici di alto livello, alti funzionari governativi, giudiziari o militari, alti dirigenti di società statali, importanti funzionari di partiti politici.',
  declarations_q3: 'Siete cittadini statunitensi o residenti negli Stati Uniti ai fini fiscali?',
  ca_q1: '1. Avete esperienza di trading?',
  ca_q2: '2. Da quanto tempo investe/negozia nei mercati finanziari?',
  ca_q3: '3. Quante transazioni ha effettuato negli ultimi due anni? <br> a. Azioni e reddito fisso (azioni e obbligazioni)',
  ca_q4: '&nbsp;&nbsp; b. Forex',
  ca_q5: '&nbsp;&nbsp; c. CFD (Contratti per differenza)',
  ca_q6: '&nbsp;&nbsp; d. Altri prodotti derivati (warrant, opzioni, diritti)',
  ca_q7: '4. Quali sono stati gli importi medi (su base mensile) che ha investito nelle seguenti categorie? <br> a. Azioni e reddito fisso (azioni e obbligazioni)',
  ca_q8: '&nbsp;&nbsp; b. Forex',
  ca_q9: '&nbsp;&nbsp; c. CFD (Contratti per differenza)',
  ca_q10: '&nbsp;&nbsp; d. Altri prodotti derivati (warrant, opzioni, diritti)',
  ca_q11: '5. Che tipo di servizi di investimento ha già utilizzato? (contiene risposte multiple)',
  ca_q12: '6. Si applica a lei uno dei seguenti punti? (contiene risposte multiple)',
  ca_q13:
    '7. Il titolo Apple viene scambiato a un prezzo di vendita di 204 dollari e a un prezzo di acquisto di 206 dollari. Acquistate 100 azioni di Apple al prezzo sopra indicato. Quale sarebbe il profitto/perdita per il vostro conto se il prezzo delle azioni Apple si muovesse a un prezzo di vendita di 190 dollari e a un prezzo di acquisto di 192 dollari e voi doveste chiudere la vostra posizione?',
  ca_q14:
    "8. Il titolo Apple viene scambiato a un prezzo di vendita di 204 dollari e a un prezzo di acquisto di 206 dollari. Si apre un'operazione CFD long (acquisto) per 100 contratti (ogni contratto indica 1 azione di Apple). La leva utilizzata è 1:5. Quale sarebbe il profitto/perdita per il vostro conto se il prezzo delle azioni Apple si muovesse a un prezzo di vendita di 190 dollari e a un prezzo di acquisto di 192 dollari e voi doveste chiudere la vostra posizione?",
  ca_q15: '9. Utilizzo di un ordine di stop loss:',
  ca_q16: '10. Il saldo del conto è basso. In quali di queste occasioni potrebbe esservi richiesto di aggiungere fondi al vostro conto?',
  ca_q17:
    "11. L'indice S&P 500 ha un prezzo di acquisto di 2700 dollari. Si decide di aprire un'operazione CFD long (acquisto) di 2 contratti. La leva utilizzata è di 1:20. Si imposta uno stop loss al prezzo di 2600 dollari e un take profit al prezzo di 3000 dollari. Supponendo che il saldo sul conto sia sufficiente e che l'ordine rimanga invariato fino al raggiungimento del prezzo di vendita stop loss o del prezzo di vendita take profit e che non si verifichino spese aggiuntive, quale sarebbe il profitto o la perdita che si registrerebbe sul conto quando la posizione viene chiusa?",
  ca_q18: '1. Qual è il suo reddito annuo complessivo?',
  ca_q19: '2. Qual è la fonte di reddito?',
  ca_q20: '3. Quale percentuale del vostro reddito annuale è legata agli obblighi finanziari?',
  ca_q21: '4. Qual è il valore stimato del vostro patrimonio?',
  ca_q22: '5. Qual è la struttura del vostro patrimonio?',
  ca_q23: '6. Qual è la stima del vostro patrimonio netto (totale attività - totale passività)?',
  ca_q24: '1. Selezionare una delle seguenti affermazioni:',
  ca_q25: '2. Quale delle seguenti affermazioni è più appropriata per voi?',
  ca_q26: '3. Qual è il più importante per il vostro stile di investimento?',
  ca_q27: '4. In base alle vostre aspettative, qual è la fluttuazione annuale del valore del vostro portafoglio che siete disposti ad accettare?',
  ca_q28: '5. Quale delle seguenti opzioni sarà considerata come il portafoglio più appropriato per voi?',
  ca_q29: "6. Qual è l'orizzonte temporale dei vostri obiettivi di investimento?",
  ca_q30: '7. Qual è il vostro obiettivo di investimento?',
  ca_q31: '8. Qual è il livello di liquidità del vostro portafoglio che siete disposti ad accettare?',
  ca_q1_ao1: 'a) Sì, ho fatto trading su un conto reale.',
  ca_q1_ao2: 'b) Sì, ho fatto trading su un conto demo.',
  ca_q1_ao3: 'c) No, ma ho utilizzato i servizi di gestione del portafoglio e/o di consulenza in materia di investimenti.',
  ca_q1_ao4: 'd) No, ma ho una conoscenza approfondita grazie alla mia formazione (laurea, master, ecc.).',
  ca_q1_ao5: 'e) No',
  ca_q2_ao6: 'a) 0 - 6 mesi',
  ca_q2_ao7: 'b) 6 - 12 mesi',
  ca_q2_ao8: 'c) 1 - 2 anni',
  ca_q2_ao9: 'd) 2 - 4 anni',
  ca_q2_ao10: 'e) Oltre 4 anni',
  ca_q3_ao11: 'I. Mai',
  ca_q3_ao12: 'II. Raramente (meno di 50 volte)',
  ca_q3_ao13: 'III. A volte (50-100 volte)',
  ca_q3_ao14: 'IV. Frequentemente (più di 101 operazioni)',
  ca_q4_ao15: 'I. Mai',
  ca_q4_ao16: 'II. Raramente (meno di 50 volte)',
  ca_q4_ao17: 'III. A volte (50-100 volte)',
  ca_q4_ao18: 'IV. Frequentemente (più di 101 operazioni)',
  ca_q5_ao19: 'I. Mai',
  ca_q5_ao20: 'II. Raramente (meno di 50 volte)',
  ca_q5_ao21: 'III. A volte (50-100 volte)',
  ca_q5_ao22: 'IV. Frequentemente (più di 101 operazioni)',
  ca_q6_ao23: 'I. Mai',
  ca_q6_ao24: 'II. Raramente (meno di 50 volte)',
  ca_q6_ao25: 'III. A volte (50-100 volte)',
  ca_q6_ao26: 'IV. Frequentemente (più di 101 operazioni)',
  ca_q7_ao27: 'i. 0',
  ca_q7_ao28: 'ii. Meno di 500 euro',
  ca_q7_ao29: 'iii. 501 euro - 2.000 euro',
  ca_q7_ao30: 'iv. 2.001 - 5.000 euro',
  ca_q7_ao31: 'v. Più di 5.001 euro',
  ca_q8_ao32: 'i. 0',
  ca_q8_ao33: 'ii. Meno di 500 euro',
  ca_q8_ao34: 'iii. 501 euro - 2.000 euro',
  ca_q8_ao35: 'iv. 2.001 - 5.000 euro',
  ca_q8_ao36: 'v. Più di 5.001 euro',
  ca_q9_ao37: 'i. 0',
  ca_q9_ao38: 'ii. Meno di 500 euro',
  ca_q9_ao39: 'iii. 501 euro - 2.000 euro',
  ca_q9_ao40: 'iv. 2.001 - 5.000 euro',
  ca_q9_ao41: 'v. Più di 5.001 euro',
  ca_q10_ao42: 'i. 0',
  ca_q10_ao43: 'ii. Meno di 500 euro',
  ca_q10_ao44: 'iii. 501 euro - 2.000 euro',
  ca_q10_ao45: 'iv. 2.001 - 5.000 euro',
  ca_q10_ao46: 'v. Più di 5.001 euro',
  ca_q11_ao47: 'a. Ricezione e trasmissione e/o esecuzione di ordini (servizi di investimento che richiedono decisioni autonome)',
  ca_q11_ao48: 'b. Consulenza sugli investimenti',
  ca_q11_ao49: 'c. Gestione del portafoglio',
  ca_q11_ao50: 'd. Nessuno',
  ca_q12_ao51: "a. Ho un'esperienza professionale rilevante",
  ca_q12_ao52: 'b. Monitoraggio regolare delle notizie/mercati',
  ca_q12_ao53: 'c. Ho frequentato un seminario o un corso sui mercati finanziari / investimenti / trading online',
  ca_q12_ao54: 'd. Nessuna delle precedenti',
  ca_q13_ao55: 'a. -€1,200',
  ca_q13_ao56: 'b. -€1,400',
  ca_q13_ao57: 'c. -€1,600',
  ca_q13_ao58: 'd. -€1,800',
  ca_q14_ao59: 'a. -€6,000',
  ca_q14_ao60: 'b. -€7,000',
  ca_q14_ao61: 'c. -€8,000',
  ca_q14_ao62: 'd. -€10,000',
  ca_q15_ao63: 'a. Vi protegge da perdite rapide',
  ca_q15_ao64: "b. Limita l'esposizione al rischio",
  ca_q15_ao65: "c. Assicura di non subire mai una perdita in un'operazione.",
  ca_q15_ao66: 'd. Vi protegge dal rischio di utilizzare la leva finanziaria',
  ca_q16_ao67: 'a. Se il prezzo del sottostante su una posizione aperta si muove contro di voi, il vostro capitale si sposta al di sotto del margine minimo di mantenimento.',
  ca_q16_ao68: 'b. Se si incorre in spese di transazione che mandano in rosso il conto.',
  ca_q16_ao69: 'c. Se una posizione CFD aperta comporta spese notturne, il conto diventa deficitario.',
  ca_q16_ao70: 'd. Tutte le cose sopra citate.',
  ca_q17_ao71: 'a. -100 o 300 dollari',
  ca_q17_ao72: 'b. -200 o 600 dollari',
  ca_q17_ao73: 'c. -$2.000 o $6.000',
  ca_q17_ao74: 'd. -4.000 dollari o 12.000 dollari',
  ca_q18_ao75: 'a. Meno di 20.000 euro',
  ca_q18_ao76: 'b. Tra 20.000 e 50.000 euro',
  ca_q18_ao77: 'c. Tra i 50.000 e i 100.000 euro',
  ca_q18_ao78: 'd. Più di 100.000 euro',
  ca_q19_ao79: 'a. Stipendio/pensione',
  ca_q19_ao80: 'b. Dividendi/ Interessi/ Cedole',
  ca_q19_ao81: 'c. Affitti',
  ca_q19_ao82: 'd. Donazioni/ Eredità',
  ca_q19_ao83: 'e. Altre fonti di reddito',
  ca_q20_ao84: 'a. Meno del 25%',
  ca_q20_ao85: 'b. Tra il 25% e il 50%',
  ca_q20_ao86: 'c. Tra il 50% e il 75%',
  ca_q20_ao87: 'd. Oltre il 75%',
  ca_q21_ao88: 'a. Meno di 100.000 euro',
  ca_q21_ao89: 'b. Tra 100.000 e 500.000 euro',
  ca_q21_ao90: 'c. Tra 500.000 e 1.000.000 euro',
  ca_q21_ao91: 'd. Più di 1.000.000 euro',
  ca_q22_ao92: 'a. Principalmente in depositi bancari',
  ca_q22_ao93: 'b. Principalmente nel settore immobiliare',
  ca_q22_ao94: 'c. Principalmente negli strumenti finanziari',
  ca_q22_ao95: 'd. Assegnato in egual misura a tutte e tre le opzioni di cui sopra.',
  ca_q22_ao96: 'e. Altro',
  ca_q23_ao97: 'a. Meno di 100.000 euro',
  ca_q23_ao98: 'b. Tra i 100.000 e i 500.000 euro',
  ca_q23_ao99: 'c. Tra 500.000 e 1.000.000 euro',
  ca_q23_ao100: 'd. Più di 1.000.000 euro',
  ca_q24_ao101: 'a. Assumo rischi che potrebbero ridurre il mio capitale investito solo in circostanze estreme.',
  ca_q24_ao102: 'b. Posso rischiare una parte del mio capitale investito per ottenere un rendimento superiore alla media.',
  ca_q24_ao103: "c. Posso rischiare una parte o l'intero capitale investito, sperando di ottenere rendimenti più elevati.",
  ca_q25_ao104: 'a. La cosa più importante per me è la sicurezza del mio capitale. Pertanto, per evitare qualsiasi perdita, sono pronto a rinunciare a rendimenti più elevati.',
  ca_q25_ao105: 'b. Per ottenere rendimenti superiori alla media, accetto di correre rischi più elevati e sono pronto ad accettare una leggera diminuzione del mio capitale.',
  ca_q25_ao106: 'c. Per ottenere rendimenti elevati sono pronto ad assumere rischi elevati anche se una parte o la totalità del mio capitale è a rischio.',
  ca_q26_ao107: 'a. Conservazione del capitale',
  ca_q26_ao108: 'b. Crescita del reddito',
  ca_q26_ao109: 'c. Speculazione',
  ca_q26_ao110: 'd. Copertura',
  ca_q27_ao111: 'a. ± 5%',
  ca_q27_ao112: 'b. ± 10%',
  ca_q27_ao113: 'c. ± 25%',
  ca_q27_ao114: 'd. ± 50%',
  ca_q28_ao115: "a. Quello che produrrà un rendimento stabile dell'1-2% nei prossimi anni.",
  ca_q28_ao116: 'b. Quella che produrrà rendimenti compresi tra -2% e +10% nei prossimi anni.',
  ca_q28_ao117:
    "c. Quello che si prevede produca rendimenti compresi tra il -15% e il +30% nel prossimo anno e che, in condizioni estreme, può addirittura portare a una perdita superiore all'importo investito.",
  ca_q29_ao118: 'a. Fino a 1 anno',
  ca_q29_ao119: 'b. Tra 1 e 3 anni',
  ca_q29_ao120: 'c. Tra i 3 e i 5 anni',
  ca_q29_ao121: 'd. Più di 5 anni',
  ca_q30_ao122: 'a. Gestione della liquidità a breve termine per far fronte a spese impreviste.',
  ca_q30_ao123: 'b. Risparmio a lungo termine.',
  ca_q30_ao124: "c. Ottenere elevati profitti anche con il rischio di perdere l'importo investito",
  ca_q31_ao125: 'a. Meno del 25%',
  ca_q31_ao126: 'b. Tra il 25% e il 50%',
  ca_q31_ao127: 'c. Tra il 50% e il 75%',
  ca_q31_ao128: 'd. Oltre il 75%',
  passport_ple_different: "Nel caso in cui il Paese di residenza e quello di emissione del documento d'identità siano diversi, si prega di caricare il Passaporto.",
  live_account: 'Conto corrente',
  agree_terms_marketing: 'Accetto di ricevere aggiornamenti di marketing da Eurotrader (vedi <a href="{PRIVACY_URL}" target="_blank">Informativa sulla privacy</a> ).',
  data_policy_text:
    'I vostri dati sono al sicuro con noi e potete annullare l\'iscrizione in qualsiasi momento. Facendo clic qui sotto, confermate di aver letto e accettato i <a href="{TERMS_CONDITIONS_URL}" target="_blank">T&amp;C</a> e l\'<a href="{RISK_DISCLOSURE_URL}" target="_blank"> informativa sui rischi</a> e acconsentite alla memorizzazione e all\'elaborazione dei vostri dati personali.',
  live_tos_with_link: 'Ho letto, compreso e accettato i termini e le condizioni e l\'informativa sui rischi <a href="{URL}" target="_blank">qui riportati</a>.',
  must_agree_marketing_terms: 'Spuntare la casella di controllo per procedere alla fase successiva',
  tick_checkboxes: 'Spuntare le caselle di controllo per procedere',
  partner_account: 'Conto partner',
  privacy_policy: 'Informativa sulla privacy',
  trade: 'opera',
  pamm_investor_selection_note:
    '* Si noti che i "conti investitori" sono progettati specificamente per essere utilizzati in connessione con un conto Master e non possono essere negoziati manualmente. Per ulteriori informazioni sui conti degli investitori, contattare l\'assistenza clienti.',
  crypto_note_text:
    'Gentile cliente,<br><br>Siamo lieti di annunciare che i nostri servizi di deposito e prelievo di criptovalute sono stati aggiornati con una selezione di monete tra cui scegliere, tra cui Ethereum, Ripple, Litecoin e altre ancora. Vi ringraziamo per la pazienza e ci scusiamo per i disagi causati.<br><br><strong>Nota bene: è necessario cliccare su "Crea indirizzo" e copiare l\'ultimo indirizzo ogni volta che si desidera effettuare un deposito.</strong>',
  crypto_visit_page: "Visitate sempre questa pagina per ottenere l'indirizzo di criptovaluta più recente prima di depositare.",
  pamm_statistics_text:
    'Le statistiche Pamm sono disponibili nella nostra area clienti PAMM. Se si dispone di un account PAMM, fare clic sul link sottostante per essere reindirizzati e utilizzare le credenziali del proprio account PAMM per effettuare il login.',
  leverage: 'Leva',
  bitpace_network_warning_BTC_withdrawal:
    "Assicuratevi che l'indirizzo del portafoglio inserito sia corretto e che sia in BTC. Se si inserisce un indirizzo sbagliato, i fondi andranno persi.",
  bitpace_network_warning_LTC_withdrawal:
    "Assicuratevi che l'indirizzo del portafoglio inserito sia corretto e che sia in LTC. Se si inserisce un indirizzo sbagliato, i fondi andranno persi.",
  bitpace_network_warning_XRP_withdrawal:
    "Assicurarsi che l'indirizzo del portafoglio inserito sia corretto e che sia in XRP. Se si inserisce un indirizzo sbagliato, i fondi andranno persi.",
  bitpace_network_warning_BCH_withdrawal:
    "Assicuratevi che l'indirizzo del portafoglio inserito sia corretto e che sia in BCH. Se si inserisce un indirizzo sbagliato, i fondi andranno persi.",
  bitpace_network_warning_USDT_withdrawal:
    "Assicuratevi che l'indirizzo del portafoglio inserito sia corretto e che sia in reti ERC20 o TRC20 e che sia in USDT. Se si inserisce un indirizzo sbagliato, i fondi andranno persi.",
  bitpace_network_warning_USDC_withdrawal:
    "Assicuratevi che l'indirizzo del portafoglio inserito sia corretto e che sia in reti ERC20 o TRC20 e che sia in USDC. Se si inserisce un indirizzo sbagliato, i fondi andranno persi.",
  bitpace_network_warning_TRX_withdrawal:
    "Assicuratevi che l'indirizzo del portafoglio inserito sia corretto, che sia nella rete TRC20 e che sia in TRX. Se si inserisce un indirizzo sbagliato, i fondi andranno persi.",
  bitpace_network_warning_LINK_withdrawal:
    "Assicuratevi che l'indirizzo del portafoglio inserito sia corretto e che sia in reti ERC20 o TRC20 e che sia in LINK. Se si inserisce un indirizzo sbagliato, i fondi andranno persi.",
  payneteasy_note_text:
    'Si prega di notare che i prelievi tramite PNE sono attualmente interrotti per manutenzione; se si desidera un prelievo dopo aver depositato tramite PNE, si prega di richiedere un bonifico bancario. Per i clienti indonesiani è necessario un estratto conto bancario e il codice di compensazione e/o il codice SWIFT.',
}



// WEBPACK FOOTER //
// ./src/locale/it.js